import loopback from '@/services/loopback'

const getUID = _ => { return Math.random().toString(36).substr(2, 7) }

export default {
  namespaced: true,
  state: {
    ajaxCommands: []
  },
  getters: {
    loadingAjax (state) {
      if (state.ajaxCommands.length > 0) return true
      return false
    }
  },
  actions: {
    syncLoopback ({commit}) {
      loopback.setLoadingFunction(
        (isLoading, uid = getUID()) => {
          if (isLoading) {
            commit('addAjaxCommand', uid)
          } else {
            commit('removeAjaxCommand', uid)
          }
          return uid
        }
      )
    }
  },
  mutations: {
    addAjaxCommand (state, uid) {
      state.ajaxCommands.push(uid)
    },
    removeAjaxCommand (state, uid) {
      state.ajaxCommands.splice(
        state.ajaxCommands.indexOf(uid),
        1
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/async/index.js